import { Loading, LoadingProps } from '@nautilusbio/nb-design-system/Loading';
import { Stack, StackProps } from '@nautilusbio/nb-design-system/Stack';
import { Text, TextProps } from '@nautilusbio/nb-design-system/Text';
import { clsx } from 'clsx';
import React, { forwardRef } from 'react';

import styles from './styles.module.css';

export type FullLoadingProps = {
  addEllipsis?: boolean;
  label?: string;
  labelProps?: TextProps;
  loadingProps?: LoadingProps;
} & StackProps;

const FullLoading = forwardRef<HTMLDivElement, FullLoadingProps>(
  (
    { addEllipsis = true, fullHeight = true, fullWidth = true, label, labelProps, loadingProps, ...stackProps },
    ref,
  ) => (
    <Stack
      {...stackProps}
      alignItems={stackProps?.alignItems ?? 'center'}
      className={clsx(styles.loading, stackProps?.className)}
      fullHeight={fullHeight}
      fullWidth={fullWidth}
      ref={ref}
    >
      <Loading className={styles.loadingIcon} type="fullscreen" {...loadingProps} />

      {!!label && (
        <Text className={styles.loadingText} as="h4" {...labelProps}>
          {label}
          {addEllipsis && <>&hellip;</>}
        </Text>
      )}
    </Stack>
  ),
);

export default FullLoading;
